import {createSlice} from '@reduxjs/toolkit';

import type {PayloadAction} from '@reduxjs/toolkit';
import type {BackgroundTask} from 'src/contexts/background-task-context/useBackgroundTaskManager';

type BulkActionState = {
    uuid: string,
    shown: boolean,
    backgroundTask: BackgroundTask | null,
};

const initialState: BulkActionState = {
    uuid: '',
    shown: false,
    backgroundTask: null,
};

export const getBulkActionSlice = (name: string) => createSlice({
    name,
    initialState,
    reducers: {
        setUuid: (state, action: PayloadAction<string>) => {
            state.uuid = action.payload;
        },
        setShown: (state, action: PayloadAction<boolean>) => {
            state.shown = action.payload;
        },
        setBackgroundTask: (state, action: PayloadAction<BackgroundTask>) => {
            state.backgroundTask = action.payload;
        },
        clearResult: state => {
            state.backgroundTask = null;
            state.shown = false;
            state.uuid = '';
        },
    },
});
